import React from 'react'

const DoubleCell = ({topData, bottomData, style}) => (
  <div style={style}>
    {topData}
    <br />
    {bottomData}
  </div>
)

export default DoubleCell
